var t={getTotalCountLabel:function(t){return"".concat(t," results")},noMoreResultsLabel:"No more articles at the moment"};export{t as searchBarListTranslations};
